module.exports = __webpack_public_path__ + "img/brttz.a9304c11.png";